import { render, staticRenderFns } from "./kitchen.vue?vue&type=template&id=166d6050&scoped=true&"
import script from "./kitchen.vue?vue&type=script&lang=js&"
export * from "./kitchen.vue?vue&type=script&lang=js&"
import style0 from "./kitchen.vue?vue&type=style&index=0&id=166d6050&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d6050",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/topspuk/builds/WLymjMOvx/0/standbyteam/topspizza.co.uk/frontend/pos/components/AppHeader.vue').default})
